import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    UGASelectionNavBarItem: () => import("./components/navbar/uga-select/UGASelectionNavBarItem.vue"),
    FibeoVineyardSelectionNavBarItem: () => import("./components/navbar/fibeo-vineyard-select/FibeoVineyardSelectionNavBarItem.vue"),
    FibeoVineyardBlockSelectionNavBarItem: () => import("./components/navbar/fibeo-vineyard-block-select/FibeoVineyardBlockSelectionNavBarItem.vue"),
    FibeoVarietySelectionNavBarItem: () => import("./components/navbar/fibeo-variety-select/FibeoVarietySelectionNavBarItem.vue"),

    FibeoProduction: () => import("./components/private/FibeoProduction.vue"),
    ProductionTable: () => import("./components/private/ProductionTable.vue"),
    ProductionChart: () => import("./components/private/ProductionChart.vue"),
    ProductionVineyardBlockMap: () => import("./components/private/ProductionVineyardBlockMap.vue"),
    ProductionFarmMap: () => import("./components/private/ProductionFarmMap.vue"),
    ProductionVineyardMap: () => import("./components/private/ProductionVineyardMap.vue"),

    FibeoProductionSummary: {
        meta:{
            i18nDescrKey: "production-summary",
            filters: ["fibeo-variety-selection-nav-bar-item", "fibeo-vineyard-block-selection-nav-bar-item", "fibeo-vineyard-selection-nav-bar-item", "campaign-select-nav-bar-item", "farm-select-nav-bar-item"],
            pinnable: true,
            tag: "FIBEO"
        },
        component: () => import("./components/tiles/farm/FibeoProductionSummary.vue")
    },

    FibeoScsProductionSummary: {
        meta:{
            i18nDescrKey: "production-scs-summary",
            filters: ["fibeo-variety-selection-nav-bar-item", "fibeo-vineyard-block-selection-nav-bar-item", "fibeo-vineyard-selection-nav-bar-item", "campaign-select-nav-bar-item", "s-c-leader-select-nav-bar-item"],
            pinnable: true,
            tag: "FIBEO"
        },
        component: () => import("./components/tiles/scs/FibeoScsProductionSummary.vue")
    },

    FibeoScsProductionScs: {
        meta:{
            i18nDescrKey: "production-scs-production-scs",
            filters: ["fibeo-variety-selection-nav-bar-item", "fibeo-vineyard-block-selection-nav-bar-item", "fibeo-vineyard-selection-nav-bar-item", "campaign-select-nav-bar-item", "s-c-leader-select-nav-bar-item"],
            pinnable: true,
            tag: "FIBEO"
        },
        component: () => import("./components/tiles/scs/FibeoScsProductionScs.vue")
    },

    FibeoScsProductionUGA: {
        meta:{
            i18nDescrKey: "production-scs-production-u-g-a",
            filters: ["u-g-a-selection-nav-bar-item"],
            pinnable: true,
            tag: "FIBEO"
        },
        component: () => import("./components/tiles/scs/FibeoScsProductionUGA.vue")
    },

    FibeoScsProductionVariety: {
        meta:{
            i18nDescrKey: "production-scs-production-variety",
            filters: ["fibeo-variety-selection-nav-bar-item", "fibeo-vineyard-block-selection-nav-bar-item", "fibeo-vineyard-selection-nav-bar-item", "campaign-select-nav-bar-item", "s-c-leader-select-nav-bar-item"],
            pinnable: true,
            tag: "FIBEO"
        },
        component: () => import("./components/tiles/scs/FibeoScsProductionVariety.vue")
    },

    FibeoFarmHistory: {
        meta:{
            i18nDescrKey: "history",
            filters: [],
            pinnable: true,
            tag: "FIBEO"
        },
        component: () => import("./components/tiles/farm/FibeoFarmHistory.vue")
    },
    FibeoScsHistory: {
        meta:{
            i18nDescrKey: "history",
            filters: [],
            pinnable: true,
            tag: "FIBEO"
        },
        component: () => import("./components/tiles/scs/FibeoScsHistory.vue")
    },

    FibeoProductionVineyard: {
        meta:{
            i18nDescrKey: "production-vineyard",
            filters: [],
            pinnable: true,
            tag: "FIBEO"
        },
        component: () => import("./components/tiles/farm/FibeoProductionVineyard.vue")
    },

    FibeoProductionVineyardBlock: {
        meta:{
            i18nDescrKey: "production-vineyard-block",
            filters: [],
            pinnable: true,
            tag: "FIBEO"
        },
        component: () => import("./components/tiles/farm/FibeoProductionVineyardBlock.vue")
    },

    FibeoProductionVariety: {
        meta:{
            i18nDescrKey: "production-variety",
            filters: [],
            pinnable: true,
            tag: "FIBEO"
        },
        component: () => import("./components/tiles/farm/FibeoProductionVariety.vue")
    }
};

export default globals;
